module.exports = __webpack_public_path__ + "img/red-kiss.4bb88d2d.webp";